/* eslint-disable no-restricted-imports */
import { InjectionToken } from '@angular/core';

export const DIALOG_DATA = new InjectionToken<any>('DIALOG_DATA');

export * from './dialog-config.interface';
export * from './dialog-ref.model';
export * from './notification-ref.model';
export * from './notification-type.enum';
